import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ app }) => {
  const isAuthenticated = sessionStorage.getItem("token") !== null;

  return isAuthenticated ? <Outlet context={{ app }} /> : <Navigate to="/" />;
};

export default PrivateRoute;
